import { render, staticRenderFns } from "./ContactoModalNuevo.vue?vue&type=template&id=6ec85630&scoped=true&"
import script from "./ContactoModalNuevo.vue?vue&type=script&lang=ts&"
export * from "./ContactoModalNuevo.vue?vue&type=script&lang=ts&"
import style0 from "./ContactoModalNuevo.vue?vue&type=style&index=0&id=6ec85630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec85630",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6ec85630', component.options)
    } else {
      api.reload('6ec85630', component.options)
    }
    module.hot.accept("./ContactoModalNuevo.vue?vue&type=template&id=6ec85630&scoped=true&", function () {
      api.rerender('6ec85630', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Contactos/ContactoModalNuevo.vue"
export default component.exports